import { inject } from '@angular/core';
import {
  CanActivateFn,
  CanMatchFn,
  Router,
  UrlTree,
} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '@Env';
import { AuthService } from '@Services/auth.service';
import { ErrorDialogComponent } from '@Common/error-dialog/error-dialog.component';

function redirect(route: any, auth: AuthService, router: Router): boolean | UrlTree {
  if (route.data?.unauthenticatedRedirect) {
    return router.createUrlTree(route.data.unauthenticatedRedirect);
  } if (route.data?.keycloakRedirect === 'register') {
    auth.keycloak.register();
  } else {
    auth.keycloak.login({ idpHint: environment.authIdpHint });
  }
  return false;
}

export const authenticatedGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const dialog = inject(MatDialog);

  if (auth.isAuthenticated()) {
    return auth.ready
      .then(() => true)
      .catch((error: any) => {
        if (error instanceof HttpErrorResponse && error.status === 0) {
          console.error('[CORE-API] Service appears to be down', error);
          dialog.open(ErrorDialogComponent, {
            data: { error },
            disableClose: true,
          });
          return false;
        }
        console.error(error);
        return redirect(route, auth, router);
      });
  }
  return redirect(route, auth, router);
};

export const authenticatedMatchGuard: CanMatchFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isAuthenticated() ? true : redirect(route, auth, router);
};
